import { render, staticRenderFns } from "./NotificationPanelItems.vue?vue&type=template&id=7e290662&scoped=true"
import script from "./NotificationPanelItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationPanelItems.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationPanelItems.vue?vue&type=style&index=0&id=7e290662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e290662",
  null
  
)

export default component.exports